import { debounce } from 'lodash';
import { Howl } from 'howler';

const DEBOUNCE = 100;

export class EventMarker {
    mark() {}

    dismiss() {}
}

export class FaviconMarker extends EventMarker {
    constructor(icon, selector = 'link[rel="icon"]') {
        super();
        this.icon = icon;
        this.selector = selector;
        this.default = this.element.href;
    }

    get element() {
        return document.querySelector(this.selector);
    }

    mark() {
        this.element.href = this.icon;
    }

    dismiss() {
        this.element.href = this.default;
    }
}

export class SoundMarker extends EventMarker {
    constructor(sources, options) {
        super();
        this.sources = sources;
        this.options = options || {};
    }

    get sound() {
        if (!this._sound) {
            this._sound = new Howl({
                src: this.sources,
                preload: true,
                autoplay: false,
                loop: false,
                volume: 1.0,
                ...this.options,
            });
            this._sound.on('fade', () => {
                this.sound.stop();
            });
        }

        return this._sound;
    }

    get volume() {
        return this.options.volume || 1.0;
    }

    get duration() {
        return this.options.duration || 0;
    }

    mark() {
        if (this.sound.playing()) {
            return;
        }

        this.sound
            .stop()
            .volume(this.volume)
            .play();

        if (this.duration) {
            this.sound.fade(this.volume, 0.0, this.duration);
        }
    }
}

export class EventNotifier {
    constructor(markers) {
        this.markers = markers;
    }

    notify = debounce(() => {
        for (const marker of this.markers) {
            marker.mark();
        }
    }, DEBOUNCE);

    dismiss() {
        for (const marker of this.markers) {
            marker.dismiss();
        }
    }
}
